// Single source of truth for the personnel-type / escalation-level vocabulary used across
// all-personnel, associated-personnel, and any other page that reads ui_personnel/ui_personnel_mapping.
// Mirrors the backend's ConsumableManager.Enums.PersonnelType/EscalationLevel - wire format stays
// a raw number, these enums are for readability at the call sites that used to hardcode 0/1/2/1/2/3.

export enum PersonnelType {
  External = 0,
  InternalRegion = 1,
  InternalCoc = 2,
}

export enum EscalationLevel {
  Low = 1,
  Medium = 2,
  High = 3,
}

// i18n translation keys (not display strings) - callers still run these through their own t().
export const PERSONNEL_TYPE_LABEL_KEYS: Record<PersonnelType, string> = {
  [PersonnelType.External]: 'customer',
  [PersonnelType.InternalRegion]: 'sms_admin',
  [PersonnelType.InternalCoc]: 'sms_entity',
};

export const ESCALATION_LEVEL_LABEL_KEYS: Record<EscalationLevel, string> = {
  [EscalationLevel.Low]: 'escalation_low',
  [EscalationLevel.Medium]: 'escalation_medium',
  [EscalationLevel.High]: 'escalation_high',
};

export function isInternalPersonnel(flagInternal: number): boolean {
  return flagInternal > PersonnelType.External;
}
